import { BrokerWriteGate } from '@/features/brokers/components/broker-write-gate.component';
import { useSelectedBrokerWriteGuard } from '@/features/brokers/hooks';
import { EditQuoteLayout } from '@/features/quotes/components/layout/edit-quote-layout.component';
import { QuoteParamsProvider } from '@/features/quotes/context/quote-params.context';
import { requirePermissions } from '@/shared/utils';
import {
  createFileRoute,
  redirect,
  useParams,
  useSearch,
} from '@tanstack/react-router';

export const Route = createFileRoute('/_app/quotes/$policyId/edit')({
  component: EditQuoteRoute,
  beforeLoad: async () => {
    const hasPermission = await requirePermissions(['policies.quotes.write']);
    if (!hasPermission) {
      throw redirect({ to: '/dashboard' });
    }
  },
  validateSearch: (search: Record<string, unknown>) => {
    return {
      mode: (search.mode as 'edit' | 'view') || 'edit',
    };
  },
});

function EditQuoteRoute() {
  const params = useParams({ strict: false });
  const search = useSearch({ strict: false }) as {
    mode?: 'edit' | 'view';
  };
  const mode = search.mode || 'edit';
  const quoteWriteGuard = useSelectedBrokerWriteGuard('quote');
  // Modo somente leitura não escreve nada: não trava.
  const guard = mode === 'view' ? { blocked: false } : quoteWriteGuard;

  return (
    <BrokerWriteGate guard={guard} backTo='/quotes'>
      <QuoteParamsProvider>
        <EditQuoteLayout policyId={params.policyId as string} mode={mode} />
      </QuoteParamsProvider>
    </BrokerWriteGate>
  );
}
